import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3344_8386)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M13.3332 5.60004L7.99984 1.33337L2.6665 5.60004V14.6667H13.3332V5.60004Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M14.6666 6.66671L7.99992 1.33337L1.33325 6.66671",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3344_8386",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "currentColor"
		})
	}) })]
});
export default SvgHome;
